export const IMPROPPER_FORMATTING =
  'Anchor path should contain an absolute root path `/` and selector `#` Ex: `/about#team`';
export const INVALID_HASH =
  'Anchor Links plugin attempted to scroll to an invalid hash on route change.';
